/**
 * @property {string} light - Светлая тема. Не перебивается системной темой
 * @property {string} dark - Тёмная тема. Не перебивается системной темой
 * @property {string} colored - Цветная тема. Не перебивается системной темой
 * @property {string} onOverlay - Тема, оптимизированная для оверлеев. Не перебивается системной темой
 * @property {string} adaptiveLight - Тема, адаптирующаяся к системной. По умолчанию светлая
 */
export let ETheme = /*#__PURE__*/function (ETheme) {
  ETheme["light"] = "light";
  ETheme["dark"] = "dark";
  ETheme["colored"] = "colored";
  ETheme["onOverlay"] = "onOverlay";
  ETheme["adaptiveLight"] = "adaptiveLight";
  return ETheme;
}({});